import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { ContentPreview } from 'esocial.web.react.lib/cjs/components/util/ContentPreview';
import { CustomTable } from 'esocial.web.react.lib/cjs/components/util/Table';
import { IdentificacaoTrabalhador, TituloPagina } from 'esocial.web.react.lib/cjs/components/util/Text';
import { useAppDispatch } from 'esocial.web.react.lib/cjs/hooks/Reduz';
import { useRequisicaoControlada } from 'esocial.web.react.lib/cjs/hooks/RequisicaoControlada';
import { abrirModalConfirmacao, fecharModalConfirmacao } from "esocial.web.react.lib/cjs/store/reducers/modais";
import { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const ContainerBotoesPagina = styled('div')(({ theme }) => ({
    marginBottom: theme.spacing(1.5),
    display: 'inline-block',
    float: 'right'
}));

const ContainerBotaoVoltar = styled('div')(() => ({
    margin: '48px 0 0',
    display: 'flex',
    flexDirection: 'row'
}));

const ContainerBotoesTabelaAcao = styled(TableCell)(({ theme }) => ({
    '& > *': {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        padding: theme.spacing(1),
    }
}));

const NenhumRegistroEncontrado = styled(Typography)(() => ({
    marginTop: '5rem'
}));

function MonitoramentoSaudeListagem() {
    const { idTrabalhador, idContrato, tsv, admPreliminar } = useParams();
    const [modelo, setModelo] = useState(null);
    const { get, excluir } = useRequisicaoControlada();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const processamentoResposta = (conteudoResposta) => {
        setModelo(conteudoResposta);
    };

    async function inicializarModelo(idContrato, tsv, admPreliminar) {
        await get(`sst/monitoramentoSaude/obterListaMonitoramentoSaudePorContrato/${idContrato}/${tsv}/${admPreliminar}`, processamentoResposta, undefined, { suprimirSobreposicaoMensagens: true });
    }

    async function excluirMonitoramentoSaude(idEvento, idContrato, tsv, admPreliminar) {
        const modalConfirmacaoProps = {
            texto: 'Tem certeza que deseja excluir o registro?',
            textoBotaoNao: 'Não',
            textoBotaoSim: 'Sim',
            actionBotaoNao: () => {
                dispatch(fecharModalConfirmacao());
            },
            actionBotaoSim: async () => {
                const aposExclusao = () => {
                    // Tratamento para exclusões executadas via Assinadoc
                    if (location.pathname === '/assinadoc') {
                        navigate(`/monitoramentoSaude/${idTrabalhador}/${idContrato}/${tsv}/${admPreliminar}`);
                    }
                    else {
                        // Atualizar a lista de monitoramento por contrato, removendo o registro excluído
                        setModelo({ ...modelo, listaMonitoramentoSaudePorContrato: modelo.listaMonitoramentoSaudePorContrato.filter((x) => x.idEvento !== idEvento) });
                    }
                };

                await excluir(`sst/monitoramentoSaude/excluirMonitoramentoSaude/${idEvento}/${idContrato}/${tsv}/${admPreliminar}`, aposExclusao);
            }
        };

        dispatch(abrirModalConfirmacao(modalConfirmacaoProps));
    }

    useEffect(() => {
        inicializarModelo(idContrato, tsv, admPreliminar);
    }, []);

    return (
        modelo !== null ?
            <Fragment>
                <TituloPagina>Monitoramento de Saúde</TituloPagina>
                <IdentificacaoTrabalhador
                    cpf={modelo.identificacaoTrabalhador.cpf}
                    nome={modelo.identificacaoTrabalhador.nome}
                    categoria={modelo.identificacaoTrabalhador.categoria.codigo}
                    matricula={modelo.identificacaoTrabalhador.matricula} />

                <div>
                    <ContainerBotoesPagina>
                        <Button variant="contained" color="primary"
                            onClick={() => navigate(`/monitoramentoSaude/registrar/${idTrabalhador}/0/${idContrato}/${tsv}/${admPreliminar}`)}
                            startIcon={<AddIcon />}>
                            Registrar Exame Médico Ocupacional
                        </Button>
                    </ContainerBotoesPagina>
                </div>

                {
                    modelo.listaMonitoramentoSaudePorContrato.length > 0 ?
                        <Fragment>
                            <CustomTable>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Data do Atestado de Saúde Ocupacional</TableCell>
                                        <TableCell align="center">Tipo de Exame</TableCell>
                                        <TableCell align="center">Ação</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {modelo.listaMonitoramentoSaudePorContrato.map((linha) => (
                                        <TableRow key={linha.idEvento}>
                                            <TableCell align="center">{(new Date(linha.dataASO)).toLocaleDateString('pt-BR')}</TableCell>
                                            <TableCell align="center">{linha.tipoExameOcupacional + ' - ' + linha.descricaoTipoExameOcupacional}</TableCell>
                                            <ContainerBotoesTabelaAcao align="center">
                                                <Tooltip title="Visualizar">
                                                    <IconButton aria-label="visualizar evento" onClick={() => navigate(`/monitoramentoSaude/visualizar/${idTrabalhador}/${linha.idEvento}/${idContrato}/${tsv}/${admPreliminar}`)}>
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip title="Retificar">
                                                    <IconButton aria-label="retificar evento" onClick={() => navigate(`/monitoramentoSaude/retificar/${idTrabalhador}/${linha.idEvento}/${idContrato}/${tsv}/${admPreliminar}`)}>
                                                        <EditIcon />
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip title="Excluir">
                                                    <IconButton aria-label="excluir evento" onClick={() => excluirMonitoramentoSaude(linha.idEvento, modelo.idContrato, modelo.tsv, admPreliminar)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </ContainerBotoesTabelaAcao>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </CustomTable>
                        </Fragment> :
                        <NenhumRegistroEncontrado>Não há Monitoramento de Saúde registrado para o(a) trabalhador(a).</NenhumRegistroEncontrado>
                }
                <ContainerBotaoVoltar>
                    <Button variant="outlined" color="secondary" size="medium" onClick={() => {
                        if (tsv == "false") {
                            navigate(`/gestaoTrabalhadores/${idTrabalhador}`);
                        } else {
                            navigate(`/gestaoTrabalhadoresTsv/${idTrabalhador}`);
                        }
                    }}>
                        Voltar
                    </Button>
                </ContainerBotaoVoltar>
            </Fragment> :
            <ContentPreview />
    );
}

export default MonitoramentoSaudeListagem;
